import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from '../assets/logo.png';

export default function Header() {
    const [navbarOpen, setNavbarOpen] = useState(false);

    // This function closes the menu when a link is clicked
    const handleNavLinkClick = () => {
        window.scrollTo(0, 0);
        setNavbarOpen(false);
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-light sticky-top">
            <div className="container px-5">
                <a className="navbar-brand" href="/">
                    <img
                        src={logo}
                        alt="Logo"
                        style={{ height: "40px", width: "auto" }}
                    />
                </a>

                {/* 1. Added onClick to toggle state */}
                {/* 2. Removed 'data-bs-toggle' so React controls it, not Bootstrap JS */}
                <button
                    className="navbar-toggler"
                    type="button"
                    onClick={() => setNavbarOpen(!navbarOpen)}
                    aria-controls="navbarSupportedContent"
                    aria-expanded={navbarOpen}
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                {/* 3. Dynamically add the 'show' class based on state */}
                <div className={`collapse navbar-collapse ${navbarOpen ? "show" : ""}`} id="navbarSupportedContent">
                    <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <NavLink
                                className={({ isActive }) =>
                                    isActive ? "nav-link active" : "nav-link"
                                }
                                to="/"
                                onClick={handleNavLinkClick}
                            >
                                Home
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                className={({ isActive }) =>
                                    isActive ? "nav-link active" : "nav-link"
                                }
                                to="/about"
                                onClick={handleNavLinkClick}
                            >
                                About
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                className={({ isActive }) =>
                                    isActive ? "nav-link active" : "nav-link"
                                }
                                to="/books"
                                onClick={handleNavLinkClick}
                            >
                                Books
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                className={({ isActive }) =>
                                    isActive ? "nav-link active" : "nav-link"
                                }
                                to="/faq"
                                onClick={handleNavLinkClick}
                            >
                                FAQ
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                className={({ isActive }) =>
                                    isActive ? "nav-link active" : "nav-link"
                                }
                                to="/contact"
                                onClick={handleNavLinkClick}
                            >
                                Contact
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}